<div class="container d-block d-md-flex" appMobileView [tabs]="{left: 'Organisation', middle: 'Jobs'}">
  <div class="left-column">
    <app-loader-2 *ngIf="!(orgInfo$ | async)"></app-loader-2>
    <div class="profile-information block" *ngIf="orgInfo$ | async as orgInfo">
      <!-- <button class="profile-menu-btn">
        <svg viewBox="0 0 20 20">
          <use href="#menu-dots" /></svg>

        <div class="options-menu">
          <a href="#" class="menu-item d-flex">
            <div class="icon">
              <svg viewBox="0 0 15 15">
                <use href="#sub-edit-profile" /></svg>
            </div>
            Edit profile
          </a>
          <a href="#" class="menu-item d-flex">
            <div class="icon">
              <svg viewBox="0 0 15 15">
                <use href="#sub-network" /></svg>
            </div>
            Network
          </a>
          <a href="#" class="menu-item d-flex">
            <div class="icon">
              <svg viewBox="0 0 15 15">
                <use href="#sub-events" /></svg>
            </div>
            Events
          </a>
          <a href="#" class="menu-item d-flex">
            <div class="icon">
              <svg viewBox="0 0 15 15">
                <use href="#sub-gallery" /></svg>
            </div>
            Gallery
          </a>
          <a href="#" class="menu-item d-flex">
            <div class="icon">
              <svg viewBox="0 0 15 15">
                <use href="#sub-invite" /></svg>
            </div>
            Invite students and educators
          </a>
          <a href="#" class="menu-item d-flex">
            <div class="icon">
              <svg viewBox="0 0 15 15">
                <use href="#teacher" /></svg>
            </div>
            <div>
              Become
              <div class="hint">
                Tutor, admissions consultant, coach
              </div>
            </div>
          </a>
          <a href="#" class="menu-item d-flex">
            <div class="icon">
              <svg viewBox="0 0 15 15">
                <use href="#search-people" /></svg>
            </div>
            <div>
              Find
              <div class="hint">
                Tutor, admissions consultant, coach
              </div>
            </div>
          </a>
        </div>
      </button> -->

      <div class="d-flex flex-column align-items-center profile-top">
        <div class="profile-avatar">
          <app-avatar
            [src]="orgInfo.icon"
            [placeholder]="orgInfo | initials"
            class="avatar rounded-circle"
          ></app-avatar>
        </div>

        <div class="profile-name d-flex align-items-center"> {{ orgInfo?.name }} </div>
        <div class="profile-verified" *ngIf="orgInfo.is_creditable">Verified Organization</div>
        <!-- <div class="profile-actions d-flex">
          <button class="action d-flex align-items-center justify-content-center">
            <span class="icon">
              <svg viewBox="0 0 20 20">
                <use href="#friends"></use>
              </svg>
            </span>
            <div *ngIf="!orgInfo?.is_friend" (click)="connect(orgInfo?.id); orgInfo?.is_friend = !orgInfo?.is_friend">
              Connect</div>
            <div *ngIf="orgInfo?.is_friend" (click)="disconnect(orgInfo?.id); orgInfo?.is_friend = !orgInfo?.is_friend">
              Disconect</div>
          </button>
          <button class="action d-flex align-items-center justify-content-center">
            <span class="icon">
              <svg viewBox="0 0 20 20">
                <use href="#message"></use>
              </svg>
            </span>
            <div>Message</div>
          </button>
        </div> -->
      </div>
      <div class="enumerations">
        <div class="enumeration-item d-flex" *ngFor="let group of orgInfo?.agegroup">
          <div class="icon">
            <svg viewBox="0 0 20 20">
              <use href="#university" />
            </svg>
          </div>
          <span> {{group.name}} </span>
        </div>
        <div class="enumeration-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 20 20">
              <use href="#location" />
            </svg>
          </div>
          <span> Located in <a>{{ orgInfo?.location?.country?.name }}, {{ orgInfo?.location?.city?.name }}</a> </span>
        </div>
        <div class="enumeration-item d-flex" *ngIf="orgInfo?.org?.www">
          <div class="icon">
            <svg viewBox="0 0 20 20">
              <use href="#earth" />
            </svg>
          </div>
          <span>
            <a [href]="orgInfo?.org?.www">{{ orgInfo?.org?.www }}</a>
          </span>
        </div>
        <div class="enumeration-item d-flex" *ngIf="orgInfo?.org?.address">
          <div class="icon">
            <svg viewBox="0 0 20 20">
              <use href="#call" />
            </svg>
          </div>
          <span> {{ orgInfo?.org?.address }} </span>
        </div>
        <!-- <div class="enumeration-item d-flex">
          <div class="icon">
            <svg viewBox="0 0 20 20">
              <use href="#group" /></svg>
          </div>
          <span>
          </span>
        </div> -->
      </div>
      <div class="about-block">
        <div class="title">About us:</div>
        <div> {{orgInfo?.org?.about}} </div>
      </div>
    </div>
    <app-suggested-articles *appHideForGuest [articles]="articles$ | async"></app-suggested-articles>
  </div>

  <div class="middle-column d-md-block">
    <app-loader-2 *ngIf="!(job$ | async)"></app-loader-2>
    <div class="post-block block" *ngIf="job$ | async as job">
      <div class="post-top d-flex">
        <div class="author d-flex align-items-center">
          <app-avatar [src]="job.user.icon" [placeholder]="job.user | initials" class="medium right"></app-avatar>
          <div>
            <div class="name d-flex align-items-center"> {{job.user.name}} </div>
            <div class="position"> {{job.user.type_name}} </div>
          </div>
        </div>
      </div>
      <div class="post-content">
        <div class="job-wrapper">
          <div class="job-title">
            <span>Role:</span> {{job.name}}
            <div class="job-organization" *ngIf="job.organization"><span>Organization:</span> {{job.organization}}</div>
          </div>
          <div class="job-description" [innerHTML]="job.description | safeUserInput"> </div>
          <div class="job-details">
            <div class="job-detail-item d-flex align-items-center">
              <div class="icon">
                <svg viewBox="0 0 20 20">
                  <use href="#location"></use>
                </svg>
              </div>
              <app-location [city]="job.location?.city?.name" [country]="job.location?.country?.name"> </app-location>
            </div>
            <div class="job-detail-item d-flex align-items-center" *ngIf="job.children">
              <div class="icon">
                <svg viewBox="0 0 20 20">
                  <use href="#student"></use>
                </svg>
              </div>
              Job for students
            </div>
            <div class="job-detail-item d-flex align-items-center" *ngIf="job.remote">
              <div class="icon">
                <svg viewBox="0 0 20 20">
                  <use href="#work"></use>
                </svg>
              </div>
              Remote work
            </div>
            <div class="job-detail-item d-flex align-items-center" *ngIf="job.url">
              <div class="icon">
                <svg viewBox="0 0 20 20">
                  <use href="#earth"></use>
                </svg>
              </div>
              <a [href]="job.url | httpPrefix" class="ml-1">{{ job.url }}</a>
            </div>
            <!-- <div class="job-detail-item d-flex align-items-center">
              <div class="icon">
                <svg viewBox="0 0 20 20">
                  <use href="#call"></use>
                </svg>
              </div>
              302-831-4393
            </div> -->
          </div>

          <ng-container *appHideForGuest>
            <a
              [href]="'mailto:'+job.email"
              *ngIf="!job.url && job.email"
              class="job-action d-flex align-items-center justify-content-center"
            >
              Apply
            </a>

            <a
              [href]="job.url | httpPrefix"
              target="_blank"
              *ngIf="job.url"
              class="job-action d-flex align-items-center justify-content-center"
            >
              Apply
            </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="right-column d-none d-xl-block" *appHideForGuest>
    <app-suggested-profiles-right-bar
      [profiles]="suggestedProfiles$ | async"
      (connect)="onProfileConnect($event)"
      (disconnect)="onProfileDisconnect($event)"
    >
    </app-suggested-profiles-right-bar>

    <app-summer-programs-right-bar [programs]="summerPrograms$ | async"></app-summer-programs-right-bar>

    <app-after-school-programs-right-bar [afterSchoolPrograms]="afterSchoolPrograms$ | async">
    </app-after-school-programs-right-bar>

    <app-jobs-right-bar [jobs]="jobs$ | async"></app-jobs-right-bar>
  </div>
</div>
